<template>
  <div>
    <loader watch="visnetHubFaultPanelData">
      <div v-if="!faultPanelData.length">
        No Fault Events Found
      </div>
      <div v-else class="fault-panel__container">
        <b-row v-if="filtratedEvents.length" class="fault-panel__row">
          <div class="fault-panel__head--empty" />
          <VisnetFeederDiagram
            v-for="(_, index) in filtratedEvents[0].length"
            :key="`feeder${index}`"
            class="fault-panel__head"
            :feeder-name="Boolean(index) && generateFeederName(index)"
            :diagrams="diagrams[index]"
            :feeder-number="index"
            :router-params="generateParams(index)"
          />
        </b-row>
        <b-row
          v-for="(phase, phaseIndex) in filtratedEvents"
          :key="phaseIndex"
          class="fault-panel__row"
        >
          <p class="fault-panel__row-head">
            {{ phasesNames[phaseIndex] }}
          </p>
          <div
            v-for="(feeder, index) in phase"
            :key="phaseIndex + index"
            :class="{ 'd-flex align-items-center': Boolean(feeder) }"
            class="fault-panel__cell"
          >
            <FaultEventsTile fault-event-parent="Visnet" :event="feeder" />
          </div>
        </b-row>
      </div>
    </loader>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FaultEventsTile from '@/components/shared/fault-events-panel-tile';
import VisnetFeederDiagram from '@/components/shared/fault-diagram';

const PHASE_LABELS = ['L1', 'L2', 'L3', 'N'];

export default {
  name: 'VisnetHubFaultEventsPanel',
  components: { VisnetFeederDiagram, FaultEventsTile },
  data() {
    return {
      phasesNames: PHASE_LABELS
    };
  },
  computed: {
    ...mapState({
      faultPanelData: state => state.visnetHubFaultPanelData.data,
      visnetHub: state => state.substationVisnetHub.visnetHub
    }),
    ...mapGetters({
      diagrams: 'substationVisnetHub/diagrams'
    }),
    filtratedEvents() {
      return this.filterFaultPanelData() || [];
    }
  },
  async mounted() {
    const { externalVisnetHubId, projectCode, substationCode } = this.$route.params;
    const data = {
      externalVisnetHubId,
      projectCode,
      substationCode
    };
    await this.dispatchFetchFaultPanelData(data);
  },
  methods: {
    ...mapActions({
      dispatchFetchFaultPanelData: 'visnetHubFaultPanelData/fetchFaultPanelData'
    }),
    generateFeederName(index) {
      return (!!this.visnetHub.ways[index - 1] && this.visnetHub.ways[index - 1].name) || '';
    },
    generateParams(feederNumber) {
      const { projectCode, substationCode, externalVisnetHubId } = this.$route.params;

      return {
        name: 'VisnetFeederDiagram',
        params: {
          projectCode,
          substationCode,
          externalVisnetHubId,
          feederNumber
        }
      };
    },
    filterFaultPanelData() {
      if (!this.faultPanelData.length) return false;

      let maxPhaseNumber = 0;
      let maxFeederNumber = 0;

      this.faultPanelData.forEach(el => {
        if (maxPhaseNumber < el.phaseNumber) maxPhaseNumber = el.phaseNumber;
        if (maxFeederNumber < el.feederNumber) maxFeederNumber = el.feederNumber;
      });

      const sortedArray = Array(maxPhaseNumber + 1)
        .fill(null)
        .map(() => Array(maxFeederNumber + 1));

      this.faultPanelData.forEach(el => {
        sortedArray[el.phaseNumber][el.feederNumber] = el;
      });

      sortedArray.push(sortedArray.shift());
      return sortedArray;
    }
  }
};
</script>
